/* eslint-disable unicorn/filename-case */
/* eslint-disable array-callback-return */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import _ from 'lodash';
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useEffect } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { ClausesComponentVM } from 'ent-components-platform-react';
import PolicyBuildingAccordion from "../PolicyBuildingAccordion/PolicyBuildingAccordion";
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import messages from '../TWIABuildingSummaryAccordions.messages';
import metadata from './TWIACommercialPolicySummary.metadata.json';


function TWIACommercialPolicySummary(props) {

    const { commercialData, isRenewalSummary = false } = props
    const translator = useContext(TranslatorContext)
    const locations = _.get(commercialData, 'coverables.locations');
    const intlContext = useContext(IntlContext);

    const locationHeader = useCallback((data, name) => {
        return (
            <div>
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.locationHeading)}&nbsp;&nbsp;{_.get(data, 'locationNum_TWIA')}</div>
                    <div className={cx(styles.heading, styles.flexOneThird)}>{name}</div>
                </Flex>
            </div>
        )
    }, [translator])

    const generateTopicOverrides = useCallback(() => {
        if (locations === undefined) {
            return [];
        }
        const overrides = locations?.map((data, i) => {
            return {
                [`locationCard${i}`]: {
                    title: locationHeader(data, data.displayName)
                },
                [`buildingsAccordion${i}`]: {
                    isRenewalSummary
                }
            }

        });

        return Object.assign({}, ...overrides);
    }, [isRenewalSummary, locationHeader, locations]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            PolicyBuildingAccordion
        },
    }

    const overrideProps = {
        locationAccordion: {
            data: locations,
        },
        accordion:{
            className: isRenewalSummary ? 'renewalSummary': 'policySummary noborder'
        },
        buildingsAndLocationsAccordion: {
            title: isRenewalSummary ? translator(messages.coverages) : translator(messages.buildingAndLocation),
            className: isRenewalSummary ? 'accordionTitle bottomBorder': 'noborder'
        },
        ...generateTopicOverrides()
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={commercialData}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default withAuthenticationContext(withRouter(TWIACommercialPolicySummary));